<div>
  <span
    *ngFor="let x of langOptions"
    [class.selected]="isSelected(x)"
    (click)="isSelected(x) ? null : changeLang(x)"
    >{{ x }}</span
  >
</div>
